import React from 'react'

import { Box } from './core'

const _firstLeft = (arr, idx) => {
  if (idx >= arr.length) idx = arr.length - 1

  while (idx > -1 && (arr[idx] === null || arr[idx] === undefined)) idx--

  return arr[idx]
}

const _castArray = x => (Array.isArray(x) ? x : [x])

const _zipWith = (fn, a, b) => {
  const result = []
  const length = Math.max(a.length, b.length)

  for (let i = 0; i < length; i++)
    result[i] = fn(_firstLeft(a, i), _firstLeft(b, i))

  return result
}

export const AspectRatio = React.forwardRef(
  ({ x, y, children, ...props }, ref) => (
    <Box ref={ref} position="relative" {...props}>
      <Box
        pt={_zipWith(
          (x, y) => `${(y / x) * 100}%`,
          _castArray(x),
          _castArray(y),
        )}
        aria-hidden={true}
      />
      <Box position="absolute" top={0} left={0} right={0} bottom={0}>
        {children}
      </Box>
    </Box>
  ),
)
